import { NumericRange } from '../../components';
import { NumericRangeFilterOption } from '../types';

export const config: NumericRangeFilterOption = {
  id: 'omicsExplorer.filters.maximumAcrossPopulations',
  title: {
    id: 'omicsExplorer.filters.maximumAcrossPopulations',
    defaultMessage: 'Maximum Across Populations',
  },
  content: NumericRange,
  injectedProps: {
    id: 'maxAlleleFrequency',
    step: 0.01,
    defaultMaximumValue: 0.1,
    defaultMinimumValue: 0.01,
    searchKey: 'maxAlleleFrequency',
    buttonIntlLabel: {
      id: 'omicsExplorer.filters.maximumAcrossPopulations.button.placeholder',
      defaultMessage: 'Add Filter',
    },
    maxHelpMessage: {
      id: 'omicsExplorer.filters.maximumAcrossPopulations.maxHelpMessage',
      defaultMessage: '<= Max',
    },
    minHelpMessage: {
      id: 'omicsExplorer.filters.maximumAcrossPopulations.minHelpMessage',
      defaultMessage: '>= Min',
    },
  },
};
